import { EmailActivityAttachment } from "./activities";
import { Filter } from "./filter-builder";

export class LogEmailRecipient {
  id: number;
  logEmailId: number;
  receipientType: string;
  emailAddress: string;
  trackingStatus: string;
  trackingStatusUpdatedOn: string;
  logEmail: LogEmail;
}

export class LogEmailAttachment {
  id: number;
  logEmailId: number;
  name: string;
  blobUri: string;
  logEmail: LogEmail;
}

export class LogEmail {
  id: number;
  referenceId?: string;
  ts: string;
  sendAt?: string;
  sentAt?: string;
  subject: string;
  body: string;
  delivered: boolean;
  errorStatus: string;
  canceledOn?: string;
  recipients: LogEmailRecipient[];
  attachments: LogEmailAttachment[];
}

export class EmailAttachment {
  name: string;
  path: string;
}

export class LogEmailVM {
  id: number;
  roleNames: string[];
  toRecipients: string[];
  ccRecipients: string[];
  bccRecipients: string[];
  subject: string;
  body: string;
  attachments: EmailAttachment[];
  delivered: boolean;
  errorStatus: string;
  sentAtString: string;
  sendOnString: string;
  canceledOnString: string;
}

export class ApplicationLogEmailVM extends LogEmailVM {
  
}

export class LogEmailListItem {
  logEmailId: number;
  clientName: string;
  subject: string;
  sentOnString: string;
  delivered: string;
  errored: boolean;
}

export class ApplicationLogEmailListItem extends LogEmailListItem {
  workflowApplicationId: string;
  applicationNumber: string;
  workflowName: string;
  activityName: string;
  workflowApplicationActivityDataId: string;
  scheduledForString: string;
  canceledOnString: string;
}

export class GetLogEmailsRequest {
  pageSize: number;
  pageNumber: number;
  filters: Filter[];
  sortField: string;
  sortDescending: boolean;

  constructor(options?: Partial<GetLogEmailsRequest>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export class GetApplicationLogEmailsResponse {
  recordCount: number;
  pageCount: number;
  logEmails: ApplicationLogEmailListItem[];
}